<template>
    <!-- 日历排课 -->
    <el-form :model="form" ref="form" :rules="rules">
        <div class="formItemBox mb-15">
            <el-form-item label="班级名称" prop="classcoursecode">
                <!-- <SelectPage label="name" :paginationOption="paginationOption" value="name" :isMultiple="true" ref="SelectPage" /> -->
                <!-- <el-select @change="getClassCode" v-model="classParams.condition.keyword" placeholder="请选择">
                    <el-option
                    v-for="item in classOptions"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                    </el-option>
                </el-select> -->
                <SelectPage v-if="!disabled" ref="SelectPage" :listLoading="false" @getSelectValue="getSelectClass" label="name" value="code" :list="classOptions" :isMultiple="false" :paginationOption="paginationOptionClass" />
                <el-input v-else :disabled="disabled" v-model="defaultChoiceValue" maxlength="100"></el-input>
            </el-form-item>
        </div>
        <div class="formItemBox mb-15">
            <el-form-item label="对应课程" prop="classcoursecode">
                <SelectPage v-if="!courseDisabled" ref="SelectPageCourse" :listLoading="false" @getSelectValue="getSelectCourse" label="name" value="code" :list="CourseOptions" :isMultiple="false" :paginationOption="paginationOptionCourse" />
                 <el-input v-else :disabled="courseDisabled" v-model="defaultCourseValue" maxlength="100"></el-input>
            </el-form-item>
        </div>
        <div class="formItemBox mb-15">
            <el-form-item label="授课课时" prop="periodcount">
                <el-input v-model="form.periodcount" maxlength="100"  placeholder="授课课时"></el-input>
            </el-form-item>
        </div>
        <div class="formItemBox setTimeBtnBox mb-15">
            <el-form-item label="上课时间" prop="schooltime">
                <el-select @change="getTimes" v-model="timeArr" multiple placeholder="请选择">
                    <el-option
                    v-for="item in timeOptions"
                    :key="item.code"
                    :label="item.timeStr"
                    :value="item.code">
                    </el-option>
                </el-select>
            </el-form-item>
            <div class="setTimeBtn" @click="handleOpenSelectTime">设置上课时间</div>
        </div>
        <div class="formItemBox mb-15">
            <el-form-item label="上课日期" prop="begindates">
                <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="form.begindates"
                    type="dates"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
        </div>
        <div class="formItemBox mb-15">
            <el-form-item label="授课老师" prop="teachername">
                <SelectPage ref="SelectPageTeach" :listLoading="false" @getSelectValue="getSelectValue" label="orgname" value="code" :list="teachOptions" :isMultiple="true" :paginationOption="paginationOption" />
            </el-form-item>
        </div>
        <div class="formItemBox mb-15">
            <el-form-item label="授课内容" prop="">
                <el-input
                    type="textarea"
                    :rows="2"
                    maxlength="200"
                    placeholder="请输入内容"
                    v-model="form.name">
                </el-input>
            </el-form-item>
        </div>
        <AddTimeConfig ref="AddTimeConfig" @saveSuccess="saveSuccess"/>
    </el-form>
</template>
<script>
import {saveSchedule,getTeacherList,getCourseList, getClassListBySelect,getTimeconfigList} from '@/api/measApi/teachManagement.js'
import {getTableDefaultPageSize} from '@/assets/measAssets/js/tools.js'
import SelectPage from '@/components/measComponents/selectPage/selectPage'
import AddTimeConfig from '@//views/meas/systemManage/timeConfig/components/addTimeConfig'
export default {
    
    data(){
        return {
            form: {
                begindates: [],
                classcoursecode: '',
                periodcount: '',
                schooltime: [],
                teachercode: '',
                teachername: ''
            },
            rules: {
                classcoursecode: [
                    { required: true, message: '请选择', trigger: 'blur' }
                ],
                periodcount: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                begindates: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                schooltime: [
                    { required: true, message: '请选择', trigger: 'blur' }
                ],
                // teachername: [
                //     { required: true, message: '请选择', trigger: 'blur' }
                // ],
            },
            classParams: {
                condition: {
                    keyword: '',
                    status: 10,
                    ispaging: true
                },
            },
            classOptions: [],
            CourseOptions:[],
            paginationOption: {
                pagesize: getTableDefaultPageSize(),
                page: 1,
                total: 0
            },
            paginationOptionCourse: {
                pagesize: getTableDefaultPageSize(),
                page: 1,
                total: 0
            },
            paginationOptionClass: {
                pagesize: getTableDefaultPageSize(),
                page: 1,
                total: 0
            },
            timeParams: {
                condition: {
                    description: ''
                },
                orderbyname: '',
                orderbyorder: '',
                page: 1,
                pagesize: getTableDefaultPageSize()
            },
            timeOptions: [],
            timeArr: [],
            classCourseParams: {
                condition: {
                    classcode: '',
                    classname: '',
                    status: 10,
                    name: ''
                }
            },
            teachParams: {
                condition: {
                    innerid: '',
                    orgname: ''
                },
                orderbyname: '',
                orderbyorder: '',
                page: 1,
                pagesize: getTableDefaultPageSize()
            },
            teachOptions:[],
            disabled: false,
            defaultChoiceValue: '',
            courseDisabled: false,
            defaultCourseValue: ''
        }
    },
    props: {
        classCode: {
            type: String,
        },
        className: {
            type: String
        },
        classCourseCode: {
            type: String
        },
        classCourseName: {
            type: String
        }
    },
    watch: {
        classCode: {
            handler(newVal){
                if(newVal){
                    this.disabled = true
                    this.form.classcoursecode = newVal
                    this.classCourseParams.condition.classcode = newVal
                    this.getCourseList()
                }
            },
            immediate: true
        },
        className: {
            handler(newVal){
                if(newVal){
                    this.defaultChoiceValue = newVal
                }
            },
            immediate: true
        },
        classCourseName: {
            handler(newVal){
                if(newVal){
                    this.defaultCourseValue = newVal
                    console.log(this.defaultCourseValue,'newVal')
                }
            },
            immediate: true
        },
        classCourseCode: {
            handler(newVal){
                if(newVal){
                    this.courseDisabled = true
                    this.form.classcoursecode = newVal
                }
            },
            immediate: true
        },
    },
    components: {
        SelectPage,
        AddTimeConfig
    },
    created(){
        // this.init()
    },
    methods: {
        init(){
            if(!this.disabled){
                this.$refs.SelectPageCourse.choiceValue = {}
                this.$refs.SelectPageTeach.choiceValue = []
            }
            this.timeArr = []
            this.getClassListBySelect()
            this.getTimeconfigList()
            this.getTeacherList()
        },
        //设置上课时间
        handleOpenSelectTime(){
            this.$refs.AddTimeConfig.handleOpen()
        },
        saveSuccess(){
            this.getTimeconfigList()
        },
        // 班级下拉获取
        getClassListBySelect(){
            getClassListBySelect(Object.assign(this.classParams, this.paginationOptionClass)).then(res => {
                this.classOptions = res.data
                console.log(res,'班级下拉')
            })
        },
        // 获取选择的班级code
        // getClassCode(value){
        //     // this.form.classcoursecode = value
        //     this.classCourseParams.condition.classcode = value
        //     this.getCourseList()
        //     console.log(value)
        // },
        getSelectClass(value){
            // this.classParams.condition.keyword = value[0].code
            this.form.classcoursecode = value[0].code
            this.classCourseParams.condition.classcode = value[0].code
            this.getCourseList()
        },
        // 获取班级课程下拉
        getCourseList(){
            getCourseList(Object.assign(this.classCourseParams, this.paginationOptionCourse)).then(res => {
                console.log(res,'班级课程下拉')
                this.CourseOptions = res.data
                this.paginationOptionCourse.total = res.pageinfo.rowcount
            })
        },
        getSelectCourse(value){
            this.form.classcoursecode = value[0].code
        },
        // 获取时间段下拉
        getTimeconfigList(){
            getTimeconfigList(this.timeParams).then(res => {
                console.log(res,'时间段下拉')
                let arr = JSON.parse(JSON.stringify(res.data))
                arr.forEach(element => {
                    element.timeStr = element.starttime+'-'+element.endtime
                });
                this.timeOptions = arr
            })
        },
        getTimes(code){
            console.log(code,'code')
            let arr = []
            this.timeOptions.forEach(item => {
                code.forEach(itm => {
                    if(item.code === itm){
                        arr.push({
                            starttime: item.starttime,
                            endtime: item.endtime
                        })
                    }
                })
                
            })
            this.form.schooltime = arr
        },
        // 获取老师下拉
        getTeacherList(){
            getTeacherList(Object.assign(this.teachParams,this.paginationOption)).then(res => {
                this.teachOptions = res.data
                this.paginationOption.total = res.pageinfo.rowcount
                console.log(res,'老师')
            })
        },
        // 获取老师code
        getSelectValue(value){
            let arrName = []
            let arrCode = []
            value.forEach(item => {
                arrName.push(item.orgname)
                arrCode.push(item.code)
            })
            this.form.teachercode = arrCode.toString()
            this.form.teachername = arrName.toString()
            console.log(value,'老师code')
        },
        handleClose(){

        },
        submit(formName){
            console.log(this.form,'this.form')
             this.$refs[formName].validate((valid) => {
          if (valid) {
                this.saveSchedule(formName)
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        saveSchedule(formName){
            saveSchedule(this.form).then(res => {
                if(res.code === '000'){
                    this.$refs[formName].resetFields();
                    this.$message.success(res.msg)
                    this.handleClose()
                    this.$emit('handleClose1')
                }else{
                    this.$message.error(res.msg)
                }
            })
        }
    }
        
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body{
    padding: 0!important;
}
.setTimeBtnBox{
    align-items: flex-end!important;
}
.setTimeBtn{
    height: 36px;
    background: #0B75FA;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    padding: 0 20px;
    cursor: pointer;
}
.scheduleConte{
    .weekContent{
        align-items: center;
        // border-right: 1px solid #EAEAEA;
        .item{
            text-align: center;
            font-size: 14px;
            color: #666666;
            height: 32px;
            width: 68px;
            border: 1px solid #EAEAEA;
            cursor: pointer;
        }
        .activeItem{
            border: 1px solid #409EFF;
            color: #409EFF;
        }
    }
    >.el-scrollbar__wrap{
        padding: 0!important;
    }
    .modelBox{
        background: #F6F7FB;
        height: 44px;
        color: #666666;
        font-size: 14px;
        line-height: 44px;
        .gzModel,.dateMode{
            padding: 0 20px;
            cursor: pointer;
        }
        .activeModel{
            background: white;
        }
    }
    .formContent{
        padding: 20px;
    }
}
</style>